

import {THEME_DARK_STORAGE} from '@/app/config'
import Api from '@helpers/api'
import Auth from '@helpers/auth'
import axios from 'axios'
import routeAllies from '@routes/config'

export default {
  namespaced: true,
  state: {
    ...Auth.default,
    iniAuth: false,
    dark: 1
  },
  getters: {
    isLogin: s => s.token ? (s.token.length > 0 && s.user !== undefined && s.user !== null) : false,
    getToken: s => s.token,
    getUser: s => s.user,
    getUserId: s => s.user && s.user.id,
    getUserRole: s => s.user[Auth.role_key] ? s.user[Auth.role_key].toLocaleLowerCase().trim() : '',
    themeDark: s => s.dark
  },
  actions: {
    /**
     * Action login
     * @param commit
     * @param payload
     */
    login({commit, dispatch}, payload) {
      let {token, user} = payload
      token = token ? token : Auth.default.token

      /**
       * Save locale storage
       */
      Auth.save({token, user})
      // Requests that fire before the reload below (the notifications bell)
      // must already carry the new token: their 401 would send the user to
      // /logout and wipe the session that was just saved.
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      commit('setToken', token)
      commit('setUser', user)
      dispatch('browseMode/resetForLogin', user, {root: true})
      payload.reload && window && window.location.reload()
    },

    /**
     *
     * Action logout
     * @param commit
     * @param reload
     */
    logout({commit, dispatch}, reload = false) {
      /**
       * remove locale storage
       */
      dispatch('browseMode/clear', null, {root: true})
      Auth.logout()
      const {token, user} = Auth.default
      commit('setToken', token)
      commit('setUser', user)
      // reload && window && window.location.reload();
      reload && window && (window.location.href = 'login')
    },

    /**
     * Action refresh state from localstorage
     * @param commit
     * @param dispatch
     */
    async refresh({commit, dispatch}) {

      let {token} = Auth.data() || {}
      token = token || Auth.default.token

      commit('setToken', token)
      commit('setIniAuth', true)

      if(Auth.isLogin()) {
        dispatch('browseMode/hydrate', null, {root: true})
        Api.methods.auth.checkToken()
        .then(({data}) => {
          if(data && data.data && data.success === true) {
            // console.log(data.data)
            localStorage.setItem('perms', JSON.stringify(data.data.permissions));
            localStorage.setItem('backend_routes', JSON.stringify(data.data.routes));
            localStorage.setItem('user_target', JSON.stringify(data.data.target));
            data = data.data
            Auth.save({user: data})
            commit('setUser', data)
            dispatch('browseMode/hydrate', null, {root: true})
            dispatch('sideMenu/fetchItems', {}, {root: !0})
          }
        })
      }
    },

    setUser({commit}, user) {
      Auth.save(user)
      commit('setUser', user)
    },

    setThemeDark({commit}, value) {
      value = value === true ? 1 : 0
      localStorage.setItem(THEME_DARK_STORAGE, value)
      commit('setDark', value)
    },

    async iniAuthFromStorage({state, dispatch}) {
      if(state.iniAuth === false) {
        await dispatch('refresh')
      }
      return Auth.isLogin() ? Auth.isLogin() : false
    }
  },
  mutations: {
    setToken: (state, payload) => state.token = payload,
    setUser: (state, payload) => state.user = payload,
    setDark: (state, payload) => state.dark = payload,
    setIniAuth: (state, payload) => state.iniAuth = payload
  }
}
